import { useTranslations } from 'next-intl';
import ErrorImg from '@/app/assets/imgs/plans_error.svg';

export const ErrorComponent = () => {
  const t = useTranslations();
  return (
    <div className="flex flex-col items-center">
      <img src={ErrorImg.src} alt="error" className="mb-6 w-[320px]" />
      <div className="text-center">{t('payments.networkError')}</div>
    </div>
  );
};
